import React from 'react';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { withStyles } from '@material-ui/core';
import classNames from 'classnames';
import ReportHelpers from '../ReportHelpers';

const styles = theme => ({
    noDataChart: {
      opacity: "0.5",
      pointerEvents:"none"
    },
});

class AmBasketValuesByKioskChart extends React.Component {
    constructor(props) {
        super(props);
        am4core.useTheme(am4themes_animated);
	}
	//Colleague tills are 141, 142, etc.
	//Order Points are 157 and 158
    kioskConverter = (data) => {
		data.sort((a,b) => {
			return a.Total > b.Total ? 1: -1;
		});

        for(var x = 0; x < data.length;x++) {
			data[x].Kiosk = data[x].TillNumber;
		}

		return data;
	}
	
    componentDidMount() {
		let chart = am4core.create("basketvaluesbykioskchartdiv", am4charts.XYChart);
		let title = chart.titles.create();
		title.text = "Order values by POS type";
		title.fontSize = 21;
		title.align = "left";
		title.marginBottom = 30;
		if(this.props.data.length > 0) {
			chart.exporting.menu = new am4core.ExportMenu();	
			chart.exporting.filePrefix = title.text;	
		}
		//chart.paddingRight = 40;
		chart.data = this.kioskConverter(this.props.data);
		var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = "Kiosk";
		categoryAxis.renderer.grid.template.location = 0;
		categoryAxis.renderer.minGridDistance = 30;
		chart.numberFormatter.numberFormat = "#";
		var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
		valueAxis.renderer.labels.template.adapter.add("text", (label, target, key) => {
			if(label)
				return ReportHelpers.formatCurrency(parseFloat(label));
	   	});
		var series = chart.series.push(new am4charts.ColumnSeries());
		series.dataFields.valueX = "Total";
		series.dataFields.categoryY = "Kiosk";
		series.name = "Total";
		series.columns.template.tooltipText = "{categoryY}: [bold]£{valueX}[/]";
		series.columns.template.fillOpacity = .8;
		var columnTemplate = series.columns.template;
		columnTemplate.fill = am4core.color("#004e37");
		columnTemplate.stroke = am4core.color("#00893a");
		columnTemplate.strokeWidth = 2;
		columnTemplate.strokeOpacity = 1;
		this.chart = chart;
    }  
	componentWillUnmount() {
		if (this.chart) {
			this.chart.dispose();
		}
	}
    render() {
		const { data, classes } = this.props
        return (<div id="basketvaluesbykioskchartdiv" style={{ width: "100%", height: "500px" }} className={ classNames( data.length  === 0 ? classes.noDataChart : null )}></div>);
    }
}

export default withStyles(styles)(AmBasketValuesByKioskChart);